import React, { useState, useEffect } from 'react';
import {
	Box,
	Typography,
	Button,
	Container,
	Slide,
	IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

// Consistent colors for both light and dark mode
const bannerColors = {
	background: '#1976d2',
	text: '#ffffff',
	buttonBg: '#115293',
	buttonHover: '#0d3c66',
};

const TopBanner = () => {
	const navigate = useNavigate();
	const [bannerClosed, setBannerClosed] = useState(false);

	const handleClose = () => {
		setBannerClosed(true);
		localStorage.setItem('topBannerClosed', Date.now().toString());
	};

	useEffect(() => {
		const closedTimestamp = localStorage.getItem('topBannerClosed');
		if (closedTimestamp && Date.now() - parseInt(closedTimestamp) < 86400000) {
			setBannerClosed(true);
		}
	}, []);

	if (bannerClosed) return null;

	return (
		<Slide direction="down" in={!bannerClosed} mountOnEnter unmountOnExit>
			<Box
				id="top-banner"
				sx={{
					width: '100%',
					backgroundColor: bannerColors.background,
					py: 1,
					boxShadow: 1,
					zIndex: (theme) => theme.zIndex.appBar - 1,
				}}
			>
				<Container maxWidth="lg">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 2,
						}}
					>
						{/* Sales Message */}
						<Typography
							variant="body2"
							sx={{
								color: bannerColors.text,
								fontWeight: 500,
								fontSize: {
									xs: '0.6rem',
									sm: '0.85rem',
									md: '0.9rem',
								},
								flex: 1,
							}}
						>
							🎉 Summer Sale! Save up to 30% on essential medical supplies
						</Typography>

						{/* Action Buttons */}
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
							<Button
								variant="contained"
								size="small"
								onClick={() => navigate('/')}
								sx={{
									backgroundColor: bannerColors.buttonBg,
									color: bannerColors.text,
									'&:hover': {
										backgroundColor: bannerColors.buttonHover,
										boxShadow: 1,
									},
									fontSize: {
										xs: '0.7rem',
										sm: '0.75rem',
										md: '0.8rem',
									},
									px: {
										xs: 1,
										sm: 1.5,
										md: 2,
									},
									py: {
										xs: 0.3,
										sm: 0.4,
										md: 0.5,
									},
									minWidth: {
										xs: '80px',
										sm: '90px',
									},
									textTransform: 'none',
									whiteSpace: 'nowrap',
									transition: 'all 0.2s ease',
									lineHeight: 1.2,
								}}
							>
								Shop Now
							</Button>
							<IconButton
								size="small"
								onClick={handleClose}
								sx={{
									color: bannerColors.text,
									'&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
								}}
							>
								<CloseIcon fontSize="small" />
							</IconButton>
						</Box>
					</Box>
				</Container>
			</Box>
		</Slide>
	);
};

export default TopBanner;
